// src/components/Navbar.jsx
import React, { useState } from 'react'; // Removed useRef, useEffect as we're going back to Bootstrap's JS
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logos/logo.png'; // Ensure this path is correct

// Define a reusable NavLink component for cleaner code and consistent hover effect
const NavItemLink = ({ to, children, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);
  const location = useLocation();
  const isActive = location.pathname === to;

  return (
    <li className="nav-item">
      <Link
        className={`nav-link ${isActive ? 'active-nav-link' : ''}`}
        to={to}
        onClick={onClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          position: 'relative',
          display: 'inline-block', // Keep this for the underline sizing
          color: isActive || isHovered ? '#ffc107' : '',
          transition: 'color 0.3s ease-in-out',
          paddingBottom: '8px', // Space for the underline
        }}
      >
        {children}
        <span
          style={{
            position: 'absolute',
            bottom: '0',
            left: '0',
            width: '100%',
            height: '3px',
            backgroundColor: '#ffc107',
            transform: (isHovered || isActive) ? 'scaleX(1)' : 'scaleX(0)',
            transformOrigin: 'left',
            transition: 'transform 0.3s ease-in-out',
          }}
        ></span>
      </Link>
    </li>
  );
};

function Navbar() {
  const [isNavOpen, setIsNavOpen] = useState(false); // This state will now control Bootstrap's collapse

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const closeNav = () => {
    setIsNavOpen(false);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm sticky-top">
      <div className="container">
        {/* Logo */}
        <Link className="navbar-brand d-flex align-items-center" to="/" onClick={closeNav}>
          <img
            src={logo}
            alt="LI-YO & SONS logo"
            style={{ width: '40px', height: '40px', marginRight: '10px' }}
          />
          LI-YO & SONS GROUP
        </Link>

        {/* Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleNav}
          data-bs-toggle="collapse" // Re-added Bootstrap's data attributes
          data-bs-target="#navbarNav" // Re-added Bootstrap's data attributes
          aria-controls="navbarNav"
          aria-expanded={isNavOpen}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Links */}
        {/* Reverted to Bootstrap's 'collapse' and 'navbar-collapse' classes */}
        <div className={`collapse navbar-collapse ${isNavOpen ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <NavItemLink to="/" onClick={closeNav}>Home</NavItemLink>
            <NavItemLink to="/about" onClick={closeNav}>About</NavItemLink>
            <NavItemLink to="/services" onClick={closeNav}>Services</NavItemLink>
            <NavItemLink to="/expertise" onClick={closeNav}>Expertise</NavItemLink>
            <NavItemLink to="/projects" onClick={closeNav}>Projects</NavItemLink>
            <NavItemLink to="/hse" onClick={closeNav}>HSE</NavItemLink>
            <NavItemLink to="/contact" onClick={closeNav}>Contact</NavItemLink>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
